import { useRef } from 'react';
import { useAppSelector } from 'src/store';

/**
 * 1. init component loading = false, ref = true => return true (ref)
 * 2. api call, loading = true, ref = true => if case => ref = false => return true
 * 3. api resolved, loading = false, ref = false => return false (ref)
 */

const useIsFirstRender = () => {
  const initRef = useRef<boolean>(false);
  const loading = useAppSelector((state) => state.ui.app.loading);

  if (!initRef.current) {
    initRef.current = true;
    return true;
  }

  if (loading && initRef.current) {
    return true;
  }

  return loading;
};

export default useIsFirstRender;
